import React, { ReactElement } from 'react';
import { MaintenanceContract, VehicleRec } from 'src/models';
import MoreDetails from '../MoreDetails/containers/MoreDetails';
import css from './MaintenanceContractCard.module.scss';
import { IconContract } from 'src/content/icons';
import { strings } from 'src/localization';

export interface IProps {
    maintContract: MaintenanceContract;
    vehicles: VehicleRec[];
    selectedVehicle?: string;
    theme: string;
}

const MaintenanceContractCard = (props: IProps) => {
    const maintContract = {...props.maintContract};

    const svcList: ReactElement[]= [];

    maintContract.svcDescOrderNotes.forEach((note, index) => {
        const svcItem = <div className={css.svcItem} key={'svcItem'+index}>
            <div className={css.svcNote} key={'svcNote'+index}>{note}</div>
            <div className={css.svcStatus} key={'svcStatus'+index}>{'('+maintContract.svcStatus[index]+')'}</div>
        </div>;
        svcList.push(svcItem);
    });

    const moreDetail = <MoreDetails
        headerLit={strings.MaintContractDetails}
        message={'MAINTCONTRACT'}
        vehicles={props.vehicles}
        selectedVehicle={props.selectedVehicle}>
        <div
            className={css.details}>
            <div className={css.detailsTitleStatus}>
                <div className={css.detailsTitle}>{maintContract.programDesc}</div>
                <div className={css.detailsStatus}>{maintContract.status}</div>
            </div>
            {maintContract.source !== 'SET VPP' && maintContract.source !== 'TFS VPP' ?
                <div>
                    <div className={css.mcType}>
                        {maintContract.type}
                    </div>
                    <div className={css.numItemsLit}>
                        {strings.formatString(strings.ContractIncludesNumItems, maintContract.svcDescOrderNotes.length).toString()}
                    </div>
                    <div className={css.svcList}>
                        {svcList}
                    </div>
                </div>: null}
            {maintContract.source === 'SET VPP' ?
                <div className={css.contractCategory}>
                    {maintContract.contractCategory}
                </div>:null}
            <div className={css.vendor}>
                {maintContract.vendor ? strings.ProvidedBy + ' ' + maintContract.vendor:''}
            </div>
        </div>
    </MoreDetails>;

    return (
        <div className={css.panel}>
            <div className={css.leftColumn}>
                <IconContract className={css.icon} />
            </div>
            <div className={css.middleColumn}>
                <div>
                    <div className={props.theme === 'chevrolet' ? css.progDescCV : css.progDesc}>{maintContract.programDesc}</div>
                    {moreDetail}
                </div>
            </div>
            <div className={css.rightColumn}>
                <div>{maintContract.status}</div>
            </div>
        </div>
    );
};

export default MaintenanceContractCard;